export default __webpack_public_path__ + "static/media/key-step4.5b7c2531.gif";